import { scoreHelper } from "../../../../../helpers";
import { renderMiniScore } from "./renderMiniScore";
export const renderMiniLiveScore = function (event) {
    const score = scoreHelper(event);
    return renderMiniScore(score.homeScore, score.awayScore, event.sportId, event.scoreboard);
};
//# sourceMappingURL=renderMiniLiveScore.js.map